module.exports = __webpack_public_path__ + "static/WEDDING E&M-514-fdd0b74d7ca9b8f0a8e72c71fa13962f.jpg";